export const campaignConfig = {
    campaignListConfig: 'campaign_bioderma_reward',
    campaignLuckydrawConfig: 'campaign_bioderma_luckydraw',
    campaignReviewListConfig: 'campaign_bioderma_product_review',
    campaignSurveyListConfig: 'campaign_bioderma_surveylist',
    campaignSurveyDrawListConfig: 'campaign_bioderma_surveydraw',
};

export const dashboardConfig = {
    mainDashboard: 'bioderma_homepage',
};

export const categoryConfig = {
    menuCategory: 'menu_bioderma_reward',
};

export const historyConfig = {
    purchase: 'purchase',
};

export const blobConfig = {
    folder: 'bioderma',
};
